module.exports = __webpack_public_path__ + "static/media/Kimberly Calhoun Headshot_1677030212460.7cfeb771.png";